import { getAvatarUrl } from 'shared/components/header/utils/get-avatar-url'
import { useDashboardUser } from './hooks/use-dashboard-user'
import { usePublicUser } from './hooks/use-public-user'
import { useUserStatus } from './hooks/use-user-status'
import { useUserSubaccounts } from './hooks/use-user-subaccounts'

const useUser = () => {
  const { publicUser, publicMutate } = usePublicUser()
  const { dashboardUser, dashboardMutate, isDisabled } = useDashboardUser()

  const user = !isDisabled ? dashboardUser : undefined

  const avatarUrl = getAvatarUrl(dashboardUser)

  const {
    isWsAdmin,
    checkAdminRoles,
    checkImpersonatorAdminRoles,
    isWorkspaceOwner,
    isAffiliate,
    isCustomer,
    isStudent,
    isWsAssistant,
    isRootAdmin,
    isWhiteLabelOwner,
    isSupportImpersonation,
    isSubAccountImpersonation,
    intlLocale,
    shouldShowSubAccountPage,
    isRestrictedUser,
    isSioPlanSubscriber,
  } = useUserStatus(user)

  const { subAccountsData, changeSubAccount } = useUserSubaccounts({
    dashboardUser,
    isSupportImpersonation,
  })

  return {
    // to prevent further fetching if blocked
    user,
    publicUser,
    // for header only
    dashboardUser,
    mutate: dashboardMutate,
    mutatePublic: publicMutate,
    isCustomer,
    isAffiliate,
    isStudent,
    checkAdminRoles,
    checkImpersonatorAdminRoles,
    isWorkspaceOwner,
    isWsAdmin,
    isWsAssistant,
    isLoading: !dashboardUser && !publicUser,
    isDisabled,
    isRootAdmin,
    isWhiteLabelOwner,
    isSubAccountImpersonation,
    isSupportImpersonation,
    intlLocale,
    subAccountsData,
    changeSubAccount,
    shouldShowSubAccountPage,
    isRestrictedUser,
    avatarUrl,
    isSioPlanSubscriber,
  }
}

export default useUser
